<template>
    <sub-page :fullPage="true">
        <div class="credit-wrap">
            <data-tables class="record-table"
                         ref="recordTable"
                         :data="creditTable"
                         :table-props="tableProps"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >
                <el-table-column type="index" width="40" align="center"></el-table-column>

                <el-table-column type="expand">
                    <template v-slot="{row}">
                        <div class="credit-detail">
                            <div class="row" v-for="(item, index) in row.details" :key="index">
                                <div class="type"><i class="nucfont" :class="['', 'inuc-kaoshijilu','inuc-folder-ppt', 'inuc-mockpaper'][item.type]"></i></div>

                                <div class="name"><h3>{{item.typeName}}：</h3><span>{{item.courseName}}</span></div>
<!--                                <div class="item"><h3>考试成绩：</h3><span>82</span></div>-->
                                <div class="item"><h3>获得学时：</h3><span>{{item.hours}}</span></div>
                                <div class="item"><h3>获得学分：</h3><span>{{item.credit}}</span></div>
                                <div class="time"><h3>开始时间：</h3><span>{{item.startTime}}</span></div>
                                <div class="time"><h3>结束时间：</h3><span>{{item.gainTime}}</span></div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="trainName" :label="$t('train.name')" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalHours" label="培训学时" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalCredit" label="培训学分" align="center" show-overflow-tooltip sortable></el-table-column>
                <el-table-column prop="hours" label="获得学时" align="center" show-overflow-tooltip sortable></el-table-column>
                <el-table-column prop="credit" label="获得学分" align="center" show-overflow-tooltip sortable></el-table-column>
                <el-table-column prop="finishTime" label="完成时间" align="center" show-overflow-tooltip sortable></el-table-column>
            </data-tables>
        </div>
    </sub-page>
</template>

<script>
    /**
     *  1、对接api
     *  2、优化展示数据的字段、顺序以及样式
     */
    import SubPage from '@/components/Subpage.vue'

    export default {
        components: {
            SubPage,
        },
        props: {
            'userID': String,
            'searchData':
                {
                    type: Object,
                    default() {
                        return {
                            endTime: '',
                            startTime: '',
                        }
                    }
                }
        },
        data() {
            return {
                // 表格信息开始
                creditTable: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    //rowKey: row => row.id,
                    height: "auto"
                },
                formSearch: {
                    startTime: '',
                    endTime: '',
                    limit: -1
                },
            }
        },
        mounted() {
            this.query()
        },
        computed: {},
        methods: {
            query() {
                let queryData = {
                    endTime: this.searchData.endTime,
                    startTime: this.searchData.startTime,
                }

                this.$api.getCreditDetail(this.userID, queryData).then((res) => {
                    console.log(res.package)
                    this.creditTable = res.package
                })
            },

            typeBg(type) {
                let typeColor = ''
                switch (type) {
                    case 'course':
                        typeColor = 'course'
                        break
                    case 'mock':
                        typeColor = 'mock'
                        break
                    case 'paper':
                        typeColor = 'paper'
                        break
                    default:
                        typeColor = ''
                }
                return typeColor
            },
        },
    }
</script>

<style scoped lang="scss">
    .credit-wrap {
        height: 100%;
    }

    .record-table {
        display: flex;
        flex-direction: column;
        height: 100%;

        /deep/ .el-table__expanded-cell {
            padding: 10px 30px 10px 55px;
        }
    }

    .credit-detail {
        .row {
            display: flex;
            align-items: center;
            + .row {
                margin-top: 14px;
            }
            .type {
                margin-right: 20px;
            }
            .name, .item, .time {
                display: flex;
            }
            .name {
                width: 30%;
            }
            .item {
                width: 180px;
            }
            .time {
                width: 220px;
            }
            h3 {
                color: #99a9bf;
            }
        }

        .inuc-folder-ppt {
            color: #1b86c9;
            font-size: 20px;
        }
        .inuc-mockpaper {
            color: #18c2a0;
            font-size: 20px;
        }
        .inuc-kaoshijilu {
            color: #e8942f;
            font-size: 20px;
        }
    }

    .type-bg {
        display: inline-block;
        width: 80px;
        border-radius: 1px;
        color: #fff;

        &.course {
            background-color: #1b86c9;
        }

        &.mock {
            background-color: #18c2a0;
        }

        &.paper {
            background-color: #e8942f;
        }
    }
</style>
